import React from "react";

export default function JS_Inheritance() {
  return (
    <div className="tutorial-container">
      <h1>JS Inheritance</h1>
      <p>
        This tutorial explains the concept of JS Inheritance in JavaScript OOPs.
      </p>
    </div>
  );
}
